if (!customElements.get('lp-kid-faq')) {
  customElements.define('lp-kid-faq', class extends HTMLElement {
    connectedCallback() {
      this.animations = new Map();
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.animations.forEach((state, item) => this.finish(item, state));
    }

    finish(item, state) {
      if (this.animations.get(item) !== state) return;
      item.open = state.open;
      state.animation.cancel();
      item.style.removeProperty('height');
      item.style.removeProperty('overflow');
      this.animations.delete(item);
    }

    handleClick(event) {
      const summary = event.target.closest('.lp-kid-faq__question');
      if (!summary || summary.closest('lp-kid-faq') !== this || event.defaultPrevented) return;
      if (event.target.closest('a, button, input, select, textarea')) return;
      const item = summary.parentElement;
      const previous = this.animations.get(item);
      const open = previous ? !previous.open : !item.open;
      if (!item.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (previous) this.finish(item, previous);
        return;
      }

      event.preventDefault();
      const start = item.getBoundingClientRect().height;
      if (previous) previous.animation.cancel();
      item.style.removeProperty('height');
      item.style.overflow = 'hidden';
      // Keep details open until collapse finishes so Safari can paint the answer.
      item.open = true;
      const styles = getComputedStyle(item);
      const end = open ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height
        + parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom)
        + parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
      item.style.height = `${start}px`;
      const animation = item.animate([
        { height: `${start}px` },
        { height: `${end}px` }
      ], { duration: 280, easing: 'ease-in-out', fill: 'forwards' });
      const state = { animation, open };
      this.animations.set(item, state);
      animation.onfinish = () => this.finish(item, state);
    }
  });
}
